import { Controller } from "react-hook-form";
import "../../Checkbox/style.css";
import Checkbox from "../../Checkbox";

type TControlledCheckboxProps = {
  name: string;
  error?: string;
  label: string;
  required?: boolean;
  control: any;
  className?: string;
  disabled?: boolean;
};

const ControlledCheckbox = ({ name, error, label, required, control, className, disabled }: TControlledCheckboxProps) => {
  return (
    <Controller
      disabled={disabled}
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Checkbox name={name} label={label} value={value} onChange={onChange} error={error} required={required} />
      )}
    />
  );
};

export default ControlledCheckbox;
